define(['edge/platform/viewmodel/module', './_JSInteropAspect'
], (ViewModel, JSInteropAscpect)=> {
    return angular.module('edge.platform.time', ['edge.platform.viewmodel'])
        .run(['ViewModelService',
            (ViewModelService)=> {
                ViewModelService.addAspectFactory(JSInteropAscpect);
            }]);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/time/module.js
 **/